function productionDetails() {

  return {
    restrict: 'E',
    templateUrl: 'monthly-production-details.partial.html',
    controller: 'MonthlyProductionController',
    controllerAs: 'mpc',
    scope: {
      record: '='
    },
    link:function(scope, elem, attrs, mpc){
      scope.$watch('record', function(record){
        mpc.compileMonthlyProduction(record);
      });
    }
  }
}

productionDetails.$inject = []

export default productionDetails
